// src/components/category_page/CategoryBreadcrumb.js
import React, { useMemo } from "react";
import { Link } from "react-router-dom";

function findCategoryPath(catId, list = [], path = []) {
  if (!catId) return [];
  for (const item of list || []) {
    if (!item) continue;
    const nextPath = [...path, item];
    if (item.id === catId) return nextPath;
    if (Array.isArray(item.children) && item.children.length) {
      const result = findCategoryPath(catId, item.children, nextPath);
      if (result.length) return result;
    }
  }
  return [];
}

export default function CategoryBreadcrumb({ currentCategory, categories = [], productName }) {
  const path = useMemo(
    () => findCategoryPath(currentCategory?.id, categories),
    [currentCategory?.id, categories]
  );

  return (
    <nav className="text-sm text-gray-600 mb-6" aria-label="Morzsanavigáció">
      <Link to="/kategoriak" className="text-blue-600 hover:underline">
        Solarya
      </Link>

      {path.map((cat) => (
        <span key={cat.id}>
          <span className="mx-1">/</span>
          <Link to={`/kategoriak/${cat.id}`} className="text-blue-600 hover:underline">
            {cat.name || cat.id}
          </Link>
        </span>
      ))}

      {productName && (
        <span>
          <span className="mx-1">/</span>
          <span className="font-semibold text-gray-800">{productName}</span>
        </span>
      )}
    </nav>
  );
}
